import React, { useState } from "react";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
    message: "",
  });

  const [errors, setErrors] = useState({});

  // 🔷 Handle input change
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  // 🔷 Validation function
  const validate = () => {
    let newErrors = {};

    if (!formData.name.trim()) {
      newErrors.name = "Name is required";
    }

    if (!formData.email) {
      newErrors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = "Enter a valid email";
    }

    // Mobile Validation
    if (!formData.mobile) {
      newErrors.mobile = "Mobile Number is required";
    } else if (!/^[0-9]{10}$/.test(formData.mobile)) {
      newErrors.mobile = "Enter a valid 10-digit mobile number";
    }

    if (!formData.message.trim()) {
      newErrors.message = "Message is required";
    }

    return newErrors;
  };

  // 🔷 Submit handler
  const handleSubmit = (e) => {
    e.preventDefault();

    const validationErrors = validate();

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
    } else {
      setErrors({});
      alert("Message sent successfully!");
      setFormData({
        name: "",
        email: "",
        mobile: "",
        message: "",
      });
    }
  };

  return (
    <>
      <style>{`
        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
        }

        .contact-page {
          font-family: Arial, sans-serif;
          background: #f7f9fc;
          min-height: 100vh;
        }

        /* =========================
           HEADER SECTION
        ========================= */
        .contact-header {
          height: 320px;
          background: linear-gradient(
              rgba(0,0,0,0.45),
              rgba(0,0,0,0.45)
            ),
            url("https://images.unsplash.com/photo-1523240795612-9a054b0db644")
              center/cover no-repeat;

          display: flex;
          align-items: center;
          justify-content: center;

          color: white;
          font-size: 48px;
          font-weight: bold;
          letter-spacing: 2px;
          text-align: center;
          padding: 20px;
        }

        /* =========================
           MAIN CONTAINER
        ========================= */
        .contact-container {
          max-width: 1400px;
          margin: auto;
          padding: 50px 30px;

          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 25px;
        }

        /* =========================
           COMMON CARD
        ========================= */
        .map,
        .contact-details,
        .contact-form {
          background: white;
          border-radius: 18px;
          overflow: hidden;
          box-shadow: 0 4px 15px rgba(0,0,0,0.08);
        }

        /* =========================
           MAP
        ========================= */
        .map iframe {
          width: 100%;
          height: 100%;
          min-height: 450px;
          border: none;
        }

        /* =========================
           CONTACT DETAILS
        ========================= */
        .contact-details {
          padding: 30px;
          display: flex;
          flex-direction: column;
          justify-content: center;
        }

        .contact-details h3 {
          font-size: 28px;
          margin-bottom: 25px;
          color: #222;
        }

        .contact-details p {
          margin-bottom: 18px;
          font-size: 14px;
          color: #555;
          line-height: 1.6;
          word-break: break-word;
        }

        .contact-details a {
          text-decoration: none;
          color: #0072ff;
          font-weight: 600;
        }

        .contact-details a:hover {
          text-decoration: underline;
        }

        /* =========================
           FORM
        ========================= */
        .contact-form {
          padding: 30px;
        }

        .contact-form h3 {
          font-size: 28px;
          margin-bottom: 25px;
          color: #222;
        }

        .contact-form form {
          display: flex;
          flex-direction: column;
        }

        .contact-form input,
        .contact-form textarea {
          width: 100%;
          padding: 14px 16px;
          margin-bottom: 6px;

          border: 1px solid #d0d7e2;
          border-radius: 10px;

          font-size: 15px;
          outline: none;
          transition: 0.3s;
        }

        .contact-form input:focus,
        .contact-form textarea:focus {
          border-color: #0072ff;
          box-shadow: 0 0 5px rgba(0,114,255,0.2);
        }

        .contact-form textarea {
          resize: vertical;
          min-height: 100px;
        }

        .error {
          color: red;
          font-size: 13px;
          margin-bottom: 14px;
        }

        .contact-form button {
          background: linear-gradient(45deg, #00c6ff, #0072ff);
          color: white;
          border: none;
          padding: 14px 22px;
          border-radius: 30px;
          font-size: 16px;
          font-weight: 600;
          cursor: pointer;
          transition: 0.3s;
        }

        .contact-form button:hover {
          transform: translateY(-2px);
          opacity: 0.95;
        }

        /* =========================
           LARGE TABLET
        ========================= */
        @media (max-width: 1100px) {
          .contact-container {
            grid-template-columns: 1fr 1fr;
          }

          .map {
            grid-column: span 2;
          }

          .contact-header {
            font-size: 42px;
          }
        }

        /* =========================
           TABLET
        ========================= */
        @media (max-width: 768px) {
          .contact-header {
            height: 260px;
            font-size: 34px;
            letter-spacing: 1px;
          }

          .contact-container {
            grid-template-columns: 1fr;
            padding: 35px 20px;
          }

          .map {
            grid-column: span 1;
          }

          .map iframe {
            min-height: 320px;
          }

          .contact-details,
          .contact-form {
            padding: 24px;
          }

          .contact-details h3,
          .contact-form h3 {
            font-size: 22px;
          }
        }

        /* =========================
           MOBILE
        ========================= */
        @media (max-width: 480px) {
          .contact-header {
            height: 220px;
            font-size: 28px;
            padding: 15px;
          }

          .contact-container {
            padding: 25px 15px;
            gap: 20px;
          }

          .contact-details,
          .contact-form {
            padding: 20px;
            border-radius: 14px;
          }

          .contact-details h3,
          .contact-form h3 {
            font-size: 22px;
            margin-bottom: 20px;
          }

          .contact-details p {
            font-size: 14px;
          }

          .contact-form input,
          .contact-form textarea {
            font-size: 14px;
            padding: 12px;
          }

          .contact-form button {
            width: 100%;
            font-size: 15px;
            padding: 13px;
          }

          .map iframe {
            min-height: 260px;
          }
        }
      `}</style>

      <div className="contact-page">
        {/* 🔷 HEADER */}
        <div className="contact-header">Contact Us</div>

        {/* 🔷 CONTENT */}
        <div className="contact-container">

          {/* 🔷 GOOGLE MAP */}
          <div className="map">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3755.6861292128224!2d84.78205129999999!3d19.7259827!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a22a51ff714d52d%3A0xd9996dee695fd7a5!2sSharada%20Hill%20Modern%20School!5e0!3m2!1sen!2sin!4v1775628878538!5m2!1sen!2sin"
              allowFullScreen=""
              loading="lazy"
              title="School Location"
            ></iframe>
          </div>

          {/* 🔷 CONTACT DETAILS */}
          <div className="contact-details">
            <h3>Meet Us</h3>

            <p>
              📞 <a href="tel:+919692741427">+91 9692741427</a>
            </p>

            <p>
              📧 <a href="mailto:sharadahillmodernschool2024@gmail.com">
                sharadahillmodernschool2024@gmail.com
              </a>
            </p>

            <p>📍 Sharada Hill Modern School, Odisha, India</p>
          </div>

          {/* 🔷 CONTACT FORM */}
          <div className="contact-form">
            <h3>Contact</h3>

            <form onSubmit={handleSubmit}>
              <input
                type="text"
                name="name"
                placeholder="Enter your name"
                value={formData.name}
                onChange={handleChange}
              />
              {errors.name && <div className="error">{errors.name}</div>}

              <input
                type="email"
                name="email"
                placeholder="Enter your email"
                value={formData.email}
                onChange={handleChange}
              />
              {errors.email && <div className="error">{errors.email}</div>}

              <input
                type="text"
                name="mobile"
                placeholder="Enter your Mobile Number"
                value={formData.mobile}
                onChange={handleChange}
              />
              {errors.mobile && <div className="error">{errors.mobile}</div>}

              <textarea
                rows="4"
                name="message"
                placeholder="Enter your message"
                value={formData.message}
                onChange={handleChange}
              ></textarea>
              {errors.message && (
                <div className="error">{errors.message}</div>
              )}

              <button type="submit">Send Message</button>
            </form>
          </div>

        </div>
      </div>
    </>
  );
};

export default Contact;